import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/storybook-components';

/**
 * Submit Button for the level selector of Experimental-Designs
 */
export function StartSimulationButton(props) {
  return (
    <Button
      ariaLabel={props.ariaLabel}
      tabIndex={props.tabIndex}
      onClick={props.onClick}>
      {props.children}
    </Button>
  );
}

StartSimulationButton.propTypes = {
  /**
   * List of elements that will be displayed inside button
   */
  children: PropTypes.array,
  /**
   * aria-label property for the button
   */
  ariaLabel: PropTypes.string.isRequired,
  /**
   * TabIndex value to be set for the button
   */
  tabIndex: PropTypes.number.isRequired,
  /**
   * Callback function to be executed when button is clicked
   */
  onClick: PropTypes.func.isRequired,
};

StartSimulationButton.defaultProps = {
  ariaLabel: 'Start simulation button',
  tabIndex: null,
};
